<template>
  <div class="rhcn-select-dropdown">
    <el-popover
      placement="bottom-start"
      width="auto"
      v-model="visible"
      >
      <div slot="reference" class="check-select">
        <div style="position: relative;">
          <!-- popper-append-to-body:不需要插入浮动元素,popper-class:设置类名并隐藏 -->
          <el-select
            ref="select"
            v-model="selectedValue"
            :style="{width:`${width}px`,height:`${height}px`}"
            multiple
            :placeholder="placeholder"
            :popper-append-to-body="false"
            popper-class="hide-popper"
            style="width:100%"
            :collapse-tags="true"
            :size="size">
            <el-option
              v-for="item in list"
              :key="`${item.value}_k`"
              :label="item.label"
              :value="item.value"/>
          </el-select>
          <div style="position: absolute;left: 0;top: 0;z-index: 99;"
            :style="{width:`${width}px`,height:`${height}px`}"></div>
        </div>
      </div>
      <div class="select-main" :style="{'min-width':`${width-20}px`}">
        <div class="search-button">
          <rhcn-input :size="size" v-model="searchValue" :loading="searchLoading" suffix="search">
              </rhcn-input>
        </div>
        <div class="select-div">
          <div class="select-div-auto">
            <div v-for="item in list"
              :key="item.value" class="list"
              :class="[selectedValueCache.indexOf(item.value) > -1?'selected':'']"
              @click="clickItem(item)">
              <el-checkbox @change="checkboxChangeHandler($event, index)" v-model="item.checked" style="pointer-events: none;"></el-checkbox>
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="action-buttons">
          <rhcn-button :size="size" @click.native.stop="clear">{{ $t('message.common.clear') }}</rhcn-button>
          <rhcn-button :size="size" type="primary" @click.native.stop="confirm">{{ $t('message.common.confirm') }}</rhcn-button>
        </div>
      </div>
    </el-popover>
    <div class="selected-list">
      <div class="selected-item" v-for="(item, index) in selectItems" :key="index">
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
import RhcnButton from '@/components/form/button.vue';
import RhcnInput from '@/components/form/input.vue';
import { shallowClones } from '@/utils/tools/utils';

export default {
  components: { RhcnInput, RhcnButton },
  model: {
    prop: 'initValue',
    event: 'change-initValue',
  },
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    initValue: {
      type: Array,
      default() {
        return [];
      },
    },
    width: {
      type: Number,
      default: 320,
    },
    height: {
      type: Number,
      default: 32,
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  data() {
    return {
      visible: false,
      selectedValue: this.initValue,
      selectedValueCache: shallowClones(this.initValue),
      selectItems: [],
      list: [],
      searchValue: '',
      searchLoading: false,
    };
  },
  watch: {
    searchValue: {
      handler(value) {
        this.getList(value);
      },
      deep: true,
      immediate: true,
    },
    initValue: {
      handler(value) {
        this.selectedValue = value;
        this.selectedValueCache = shallowClones(value);
        this.getList(this.searchValue);
        this.getSelectItem();
      },
      deep: true,
      immediate: true,
    },
    selectedValue: {
      handler(value) {
        this.$emit('change-initValue', value);
      },
    },
    visible: {
      handler(value) {
        if (!value) {
          this.selectedValueCache = shallowClones(this.selectedValue);
          this.searchValue = '';
          this.getList(this.searchValue);
        }
      },
    },
    options: {
      handler() {
        this.getList(this.searchValue);
      },
    },
  },
  created() {
    if (this.selectValue && this.selectValue.length) {
      this.getSelectItem();
    }
  },
  methods: {
    getSelectItem() {
      this.selectItems = [];
      this.options.forEach((item) => {
        if (this.selectedValue.indexOf(item.value) > -1) {
          this.selectItems.push(item);
        }
      });
    },
    getList(value) {
      this.list = [...this.options.filter(n => {
        if (this.selectedValueCache.indexOf(n.value) > -1) {
          n.checked = true;
        } else {
          n.checked = false;
        }
        return `${n.label}`.indexOf(value) > -1;
      })];
    },
    // 选择
    clickItem(item) {
      const index = this.selectedValueCache.indexOf(item.value);
      if (index === -1) {
        item.checked = true;
        this.selectedValueCache.push(item.value);
      } else {
        item.checked = false;
        this.selectedValueCache.splice(index, 1);
      }
    },
    clear() {
      this.selectedValueCache = [];
      this.getList(this.searchValue);
    },
    confirm() {
      this.selectedValue = shallowClones(this.selectedValueCache);
      this.visible = false;
    },
  },
};
</script>
<style lang="scss">
.arrbox {
  display: inline-block;
}
.check-select{
  line-height: 32px;
  .hide-popper{
    display: none;
  }
  .el-select__tags {
    .el-tag {
      background-color: transparent !important;
      min-width: 0 !important;
      .el-tag__close {
        display: none !important;
      }
    }
  }
}
::v-deep .el-input__suffix{
  i:not(.el-select__caret) {
    display: none;
  }
}
.select-main {
  width: 100%;
  height: 100%;
  .search-button{
    width: 100%;
    align-items: center;
    .el-input__validateIcon {
      display: none;
    }
  }
  .select-div{
    width: 100%;
    max-width: 500px;
    margin-top: 10px;
    padding:  0 10px 0 0;
    .list{
      width: 100%;
      padding: 10px 20px 10px 10px;
      color: #666;
      cursor: pointer;
      position: relative;
      box-sizing: border-box;
      margin-bottom: 1px;
      &:hover {
        background-color: #F5F7FA;
        color: #606266;
      }
      &.selected{
        color: #FFF;
        background-color: #264373;
      }
    }
    .select-div-auto{
      width: 100%;
      max-height: 300px;
      overflow-y: auto;
      .list{
        padding: 10px 30px 10px 10px;
        &.selected::after{
          right: 10px;
        }
      }
    }
  }
  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
  }
}
.rhcn-select-dropdown {
  .selected-list {
    padding-top: 10px;
    height: 160px;
    overflow: auto;
    .selected-item {
      font-weight: 400;
      font-size: 14px;
      color: #264373;
      line-height: 28px;
    }
  }
}
</style>
